import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiFormView } from "@/types/forms/form-view.types.ts";
import { ApiFormResultAnswer } from "@/types/forms/form.types.ts";
import {
  ApiPerformanceReviewInviteView,
  ApiPerformanceReviewParticipant,
  ApiPerformanceReviewParticipantFilter,
  ApiPerformanceReviewParticipantView,
  ApiPerformanceReviewParticipantViewFilter,
  ApiPerformanceReviewRespondView,
} from "@/types/performance-review.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";

export const apiEmployeePerformanceReviews = {
  getMy: (signal?: AbortSignal) => {
    return api.get<ApiPerformanceReviewRespondView[]>(
      `/api/v1/employees/performance-reviews/reviewers/my`,
      signal
    );
  },
  getById: async function (employeeId: number, reviewerId: number) {
    return api.get<ApiPerformanceReviewRespondView>(
      `/api/v1/employees/${employeeId}/performance-reviews/reviewers/${reviewerId}`
    );
  },
  getForm: async function (employeeId: number, reviewerId: number) {
    return api.get<ApiFormView>(
      `/api/v1/employees/${employeeId}/performance-reviews/reviewers/${reviewerId}/form`
    );
  },
  saveDraft: async function (employeeId: number, reviewerId: number, data: ApiFormResultAnswer[]) {
    return api.put<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/performance-reviews/reviewers/${reviewerId}/results`,
      data
    );
  },
  submitResults: async function (
    employeeId: number,
    reviewerId: number,
    data: ApiFormResultAnswer[]
  ) {
    return api.post<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/performance-reviews/reviewers/${reviewerId}/results`,
      data
    );
  },
  getMyDirectSubordinate: async function () {
    return api.get<ApiPerformanceReviewParticipant[]>(
      `/api/v1/employees/performance-reviews/participants/my-subordinates/get-all`
    );
  },
  searchMySubordinateParticipants: async function (
    filter: ApiPerformanceReviewParticipantFilter,
    signal: AbortSignal
  ) {
    return api.post<ApiPagedData<ApiPerformanceReviewParticipant>>(
      `/api/v1/employees/performance-reviews/participants/my-subordinates/search`,
      filter,
      signal
    );
  },
  searchMyFeedbacks: async function (
    filter: ApiPerformanceReviewParticipantFilter,
    signal: AbortSignal
  ) {
    return api.post<ApiPagedData<ApiPerformanceReviewParticipant>>(
      `/api/v1/employees/performance-reviews/participants/my-feedbacks/search`,
      filter,
      signal
    );
  },
  getMyAwaitingReviewerInvite: async function (signal?: AbortSignal) {
    return api.get<ApiPerformanceReviewInviteView[]>(
      `/api/v1/employees/performance-reviews/my-awaiting-reviewer-invite`,
      signal
    );
  },
  searchReviewParticipantViews: async function (
    employeeId: number,
    filter: ApiPerformanceReviewParticipantViewFilter,
    signal: AbortSignal
  ) {
    return api.post<ApiPagedData<ApiPerformanceReviewParticipantView>>(
      `/api/v1/employees/${employeeId}/performance-reviews/participant/search`,
      filter,
      signal
    );
  },
};
